export enum ProductBlockEnum {
    PRODUCT_CATEGORY_BLOCK = 'product-category-block',
    HIGHLIGHT_PRODUCT_BLOCK = 'highlight-product-block',
}
